// steps
export const IncrementStep = 'INCREMENT_STEP';
export const DecrementStep = 'DECREMENT_STEP';
export const Restart = 'RESTART';
export const EnterAnotherPlay = 'ENTER_ANOTHER_PLAY';

// badge id
export const UpdateBadgeId = 'UPDATE_BADGE_NUMBER';

// checkouts
export const GetCheckoutsRequest = '/checkout/REQUEST';
export const GetCheckoutsReceive = '/checkout/RECEIVE';
export const GetCheckoutsFailure = '/checkout/FAILURE';
export const CheckoutSelected = 'CHECKOUT_SELECTED';

// players
export const UpdatePlayerSearchQuery = 'UPDATE_PLAYER_SEARCH_QUERY';
export const RemovePlayer = 'REMOVE_PLAYER';
export const AddPlayer = 'ADD_PLAYER';
export const SelectRating = 'SELECT_RATING';
export const ToggleWantsToWin = 'TOGGLE_WANTS_TO_WIN';
export const GetPlayersRequest = '/player/REQUEST';
export const GetPlayersReceive = '/player/RECEIVE';
export const GetPlayersFailure = '/player/FAILURE';

// plays
export const PostPlayRequest = '/play/REQUEST';
export const PostPlayReceive = '/play/RECEIVE';
export const PostPlayFailure = '/play/FAILURE';